import { css } from 'linaria';

export const activeAxisPoints = css`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const axisPoint = css`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    width: 48px;
    padding: 16px;
    border: 1px solid var(--control-secondary);
    border-radius: var(--rounding-m);
    cursor: pointer;
  }
`;

export const axisPointPreview = css`
  width: 40px;
  height: 40px;
`;

export const activeAxisPoint = css`
  && {
    border: 2px solid var(--control-primary);
  }
`;

export const inactiveAxisPoint = css`
  && {
    background: repeating-linear-gradient(
      -45deg,
      var(--background-secondary) 6px,
      var(--background-secondary) 12px,
      var(--control-minor) 13px,
      var(--control-minor) 14px
    );
    pointer-events: none;

    p {
      color: #b0b0b0;
    }
  }
`;
